/**
 * Generated runtime TestId mirror for frontend/src/pages/ErrorLogs.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ErrorLogsTestIds = {
  allMinQHint: "all-min-q-hint",
  allRecordsCount: "all-records-count",
  allRecordsTable: "all-records-table",
  btnCancelClearAll: "btn-cancel-clear-all",
  btnClearAll: "btn-clear-all",
  btnConfirmClearAll: "btn-confirm-clear-all",
  btnRefresh: "btn-refresh",
  colAllException: "col-all-exception",
  colAllMessage: "col-all-message",
  colAllModule: "col-all-module",
  colAllSessionId: "col-all-session-id",
  colAllSourceType: "col-all-source-type",
  colAllTime: "col-all-time",
  colAllType: "col-all-type",
  colPatternCount: "col-pattern-count",
  colPatternException: "col-pattern-exception",
  colPatternLastSeen: "col-pattern-last-seen",
  colPatternMessage: "col-pattern-message",
  colPatternModule: "col-pattern-module",
  emptyStateCard: "empty-state-card",
  errorLogsList: "error-logs-list",
  filterPeriod: "filter-period",
  patternsCount: "patterns-count",
  patternsMinQHint: "patterns-min-q-hint",
  patternsTable: "patterns-table",
  statCardOthers: "stat-card-others",
  statCardTotal: "stat-card-total",
  statCards: "stat-cards",
  statsLoading: "stats-loading",
  systemFailuresPage: "system-failures-page",
  tabAllRecords: "tab-all-records",
  tabPatterns: "tab-patterns",
  tabs: "tabs",
  patternRow: (record_errorLogId: string) => `pattern-row-${record_errorLogId}`,
  patternRowPrefix: () => "pattern-row-" as TestIdPrefix,
  recordRow: (record_errorLogId: string) => `record-row-${record_errorLogId}`,
  recordRowPrefix: () => "record-row-" as TestIdPrefix,
  sessionChipLink: (record_errorLogId: string) => `session-chip-link-${record_errorLogId}`,
  sessionChipLinkPrefix: () => "session-chip-link-" as TestIdPrefix,
  sessionChipText: (record_errorLogId: string) => `session-chip-text-${record_errorLogId}`,
  sessionChipTextPrefix: () => "session-chip-text-" as TestIdPrefix,
  statCard: (module: string) => `stat-card-${module}`,
  statCardPrefix: () => "stat-card-" as TestIdPrefix
} as const;
